import React, {createContext} from 'react';

export interface DropdownContextProps {
    open: boolean;
    handleToggle: () => void;
    handleClose: (event: Event | React.SyntheticEvent) => void;
    handleListKeyDown?: (event: React.KeyboardEvent) => void;
    hasDivider?: boolean;
    dropdownMenuId?: string;
    anchorRef: React.RefObject<HTMLElement> | null;
}

export const DropdownContext = createContext<DropdownContextProps | undefined>(undefined);
